module.exports = __webpack_public_path__ + "img/12.a55f7c0c.png";